class TavCollectionFilterPanel extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('[data-tav-filter-open]');
    this.addEventListener('click', this.onClick);
    this.dialog.addEventListener('close', this.onClose);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.dialog?.removeEventListener('close', this.onClose);
  }
  onClick = (event) => {
    if (event.target.closest('[data-tav-filter-open]')) {
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
    } else if (event.target.closest('[data-tav-filter-close]')) {
      this.dialog.close();
    } else if (event.target === this.dialog) {
      const bounds = this.dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
    }
  };
  onClose = () => this.trigger.setAttribute('aria-expanded', 'false');
}
if (!customElements.get('tav-collection-filter-panel')) customElements.define('tav-collection-filter-panel', TavCollectionFilterPanel);
function alignCurrentCategory(root = document) {
  if (!window.matchMedia('(max-width:750px)').matches) return;
  root.querySelectorAll('.tav-catalog-subcategories').forEach((nav) => {
    const current = nav.querySelector('[aria-current="page"]');
    if (current) nav.scrollLeft += current.getBoundingClientRect().left - nav.getBoundingClientRect().left - 8;
  });
}
alignCurrentCategory();
document.addEventListener('shopify:section:load', (event) => alignCurrentCategory(event.target));
